import { Injectable } from '@angular/core';
import { BaseEndpointService, IEndpoint } from 'src/app/@core/interfaces/IEndpoint';
import { PropertyStatus } from '../models/property-status.model';

@Injectable({
  providedIn: 'root'
})
export class PropertyStatusService extends BaseEndpointService implements IEndpoint {

constructor()
{
super({route:'property-status'});
}


  getAll() {
    return this.http.get<Array<PropertyStatus>>(this.endpoint)
  }
  get(id: string) {
    throw new Error('Method not implemented.');
  }
  delete(id: string) {
    throw new Error('Method not implemented.');
  }
  update(id: String, model: {}) {
    throw new Error('Method not implemented.');
  }

}
